import { render, staticRenderFns } from "./WorkspaceLink.vue?vue&type=template&id=01da36fb&scoped=true"
import script from "./WorkspaceLink.vue?vue&type=script&lang=js"
export * from "./WorkspaceLink.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLink.vue?vue&type=style&index=0&id=01da36fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da36fb",
  null
  
)

export default component.exports